import { useEffect } from 'react';
import { trackUmamiEvent } from '@/helpers/analytics';
import { getAttributionSource } from '@/helpers/attribution';

export function useProductViewTrack(view: string): void {
  useEffect(() => {
    trackUmamiEvent('product_view', { view, source: getAttributionSource() });
  }, [view]);
}
